/*=========================================================================================
  File Name: module-send-to-developer-actions.js
  Description: SendToDeveloper Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import SendToDeveloperAPI from '@/api/SendToDeveloperAPI';
import httpClient, { FormMultiPart } from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	/**
	 * Gửi hóa đơn cho nhà phát triển (fire-and-forget, API 202 Accepted)
	 * Đóng confirm dialog → gọi API → mở success dialog hoặc failed dialog
	 */
	sendToDeveloperAsync: async function(context, { payload, file }) {
		try {
			const formData = new FormData();
			formData.append('InvoiceFileId', payload && payload.invoiceFileId ? payload.invoiceFileId : '');
			formData.append('UserName', payload && payload.userName ? payload.userName : '');
			if (file) {
				// ✅ Tên field phải khớp với property trong DTO
				formData.append('AdditionalFile', file);
			}
			return await httpClient.postAsync(
				{ url: SendToDeveloperAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/invoice', data: formData },
				true,
				true,
				FormMultiPart
			);
		} catch (error) {
			return null;
		}
	}
};
